import { InfiniteData } from '@tanstack/react-query';
import { useInfiniteQuery } from '@starsoft/common/services/query-client';
import { getchGameTags } from './service';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { UseGameTagsQueryKeyProps } from './props';
import { GameTagsQueryKeys } from '../../queryKeys';
import { PaginatedResponse } from '@starsoft/common/models';
import { GameTag } from '@/models/game/tag';
import {
  useInfiniteQueryCallbacks,
  useInfiniteQueryReset,
} from '@starsoft/common/hooks';
import { useMemo } from 'react';

export function useGameTags() {
  const queryKey: UseGameTagsQueryKeyProps = [
    GameTagsQueryKeys.Primary,
    {
      limit: 100,
    },
  ];

  const { getNextPageParam, getPreviousPageParam } =
    useInfiniteQueryCallbacks();
  useInfiniteQueryReset(queryKey);

  const { isPending, data, error, isError, refetch, ...rest } =
    useInfiniteQuery<
      PaginatedResponse<GameTag>,
      AxiosError<GenericError>,
      InfiniteData<PaginatedResponse<GameTag>>,
      UseGameTagsQueryKeyProps
    >({
      queryKey,
      queryFn: getchGameTags,
      getNextPageParam,
      getPreviousPageParam,
      initialPageParam: 1,
    });

  const gameTags = useMemo(
    () => data?.pages?.flatMap(page => page?.data),
    [data],
  );

  return {
    ...rest,
    gameTags,
    loadingGameTags: isPending,
    error,
    isError,
    refetch,
    metadata: data?.pages?.[0]?.metadata,
  };
}
